import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { shouldShowGettingStarted } from "~/store/selectors/selector.configOptions";
import { getFeatureFlag } from "~/store/selectors/selector.featureFlags";
import { makeIsLoggedUserOwnerSelector } from "~/store/selectors/selector.users";

export const RequireCanSeeGettingStarted = ({ children, redirectTo }) => {
  const getIsOwner = useMemo(makeIsLoggedUserOwnerSelector, []);
  const isOwner = useSelector(getIsOwner);
  const hasFF = useSelector((state) => getFeatureFlag(state, "getting_started"));
  const showGettingStarted = useSelector(shouldShowGettingStarted);

  return isOwner && hasFF && showGettingStarted ? children : <Navigate to={redirectTo} />;
};

RequireCanSeeGettingStarted.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireCanSeeGettingStarted.defaultProps = {
  redirectTo: "/not-found",
};
